<template>
  <div>
    <el-col>
      <h4 class="h4">
        <i class="el-icon-s-management"></i>&nbsp;&nbsp; 推荐审稿人/回避审稿人
      </h4></el-col
    >
    <el-col class="left">
      <ul class="ul">
        <li>每位投稿用户至少选择一位，不超过三位，推荐审稿人和回避审稿人。</li>

        <br/>
      </ul>
    </el-col>

    <el-form ref="form">
      <el-form-item label="推荐审稿人" style="margin-left: 20px">
        <el-tag
          :key="tag.email"
          v-for="tag in reviewersInfo.recommends"
          closable
          :disable-transitions="false"
          @close="reviewersInfo.recommends.splice(index, 1)"
          style="width: 100%"
        >
          <span class="span"> 推荐审稿人： {{ tag.name }}</span
          >邮箱： {{ tag.email }}
        </el-tag>
        <el-select
          placeholder="请选择推荐审稿人"
          size="medium"
          style="width: 100%"
          ref="recommendSelect"
          v-if="showRecommendSelect"
          v-model="reviewer"
          @change="onSelectRecommend"
        >
          <el-option
            v-for="(item, index) in allReviewers"
            :value="item"
            :key="index"
          >
            {{ item.name }}
          </el-option
          >
        </el-select>
        <el-button
          size="medium"
          style="width: 100%"
          @click="changeRecommendSelect()"
          v-else
        >
          添加推荐审稿人
        </el-button>
      </el-form-item>
      <el-form-item label="回避审稿人" style="margin-left: 20px">
        <el-tag
          :key="tag.email"
          v-for="tag in reviewersInfo.avoids"
          closable
          :disable-transitions="false"
          @close="reviewersInfo.avoids.splice(index, 1)"
          style="width: 100%"
        >
          <span class="span"> 回避审稿人： {{ tag.name }}</span
          >邮箱： {{ tag.email }}
        </el-tag>
        <el-select
          placeholder="请选择回避审稿人"
          size="medium"
          style="width: 100%"
          ref="avoidSelect"
          v-if="showAvoidSelect"
          v-model="reviewer"
          @change="onSelectAvoid"
        >
          <el-option
            v-for="(item, index) in allReviewers"
            :value="item"
            :key="index"
          >
            {{ item.name }}
          </el-option
          >
        </el-select>
        <el-button
          size="medium"
          style="width: 100%"
          @click="changeAvoidSelect()"
          v-else
        >
          添加回避审稿人
        </el-button>
      </el-form-item>
    </el-form>
    <el-row></el-row>
    <br/>
    <el-col style="text-align: left; margin-left: 20px">
      <el-button class="save" @click="ts()">保存</el-button>
    </el-col>
  </div>
</template>

<script>
import {roleList, tsReviewersInfo, getTsReviewersInfo} from "@/api/data";

export default {
  name: "RecommendInfoComponent",
  data() {
    return {
      userInfo: '',
      reviewer: {},
      allReviewers: [],
      reviewersInfo: {
        recommends: [],
        avoids: []
      },
      showRecommendSelect: false,
      showAvoidSelect: false,
    };
  },
  methods: {
    onSelectRecommend(value) {
      if (
        this.reviewersInfo.recommends.some((item) => {
          if (item.email === value.email) {
            return true
          }
        })
      ) {
        this.$message({
          message: '推荐审稿人重复！',
          type: 'warning',
          center: true
        })
        return false
      }

      this.reviewersInfo.recommends.push(value);
      this.showRecommendSelect = false;
    },
    changeRecommendSelect() {
      this.showRecommendSelect = true;
      this.$nextTick((_) => {
        this.$refs.recommendSelect.focus();
      });
    },
    onSelectAvoid(value) {
      if (
        this.reviewersInfo.avoids.some((item) => {
          if (item.email == value.email) {
            return true;
          }
        })
      ) {
        this.$message({
          message: "回避审稿人重复！",
          type: "warning",
          center: true,
        });
        return false;
      }
      this.reviewersInfo.avoids.push(value);
      this.showAvoidSelect = false;
    },
    changeAvoidSelect() {
      this.showAvoidSelect = true;
      this.$nextTick((_) => {
        this.$refs.avoidSelect.focus();
      });
    },

    getRoleList() {
      roleList({type: "审稿人"}).then((res) => {
        this.allReviewers = res.data.result;
      });
    },

    ts() {
      console.log(this.reviewersInfo)
      if (this.reviewersInfo.recommends.length === 0 && this.reviewersInfo.avoids.length === 0) {
        this.$message({
          message: '推荐/回避审稿人不能为空',
          type: 'warning'
        })
        return false
      }
      tsReviewersInfo({
        key: this.userInfo.email,
        reviewersInfo: {
          recommends: this.reviewersInfo.recommends,
          avoids: this.reviewersInfo.avoids,
        },
      }).then((res) => {
        if (res.data.result == true) {
          this.$message({
            message: "推荐/回避审稿人信息已保存",
            type: "success",
          });
        } else {
          this.$message({
            message: "推荐/回避审稿人信息保存有误",
            type: "error",
          });
        }
      });
    },
    getTs() {
      getTsReviewersInfo({key: this.userInfo.email}).then((res) => {
        if (res.data.result.reviewersInfo != null) {
          this.reviewersInfo = res.data.result.reviewersInfo
        }
      });
    },
  },
  mounted() {
    let userInfo = this.$cookie.getCookie("userInfo");
    console.log(userInfo);
    // if (userInfo == null || userInfo.type != "投稿人") {
    //   this.$message({
    //     message: "请先登录！",
    //     type: "error",
    //   });
    //   this.$router.push("index");
    // }
    this.userInfo = userInfo;
    this.getRoleList();
    this.getTs();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.h4 {
  text-align: left;
  margin-left: 20px;
}

.left {
  text-align: left;
}

.ul {
  list-style: none;
}

.span {
  float: left;
}

.ts {
  width: 150px;
  border-color: #12696e;
  border-width: 1px;
  border-radius: 0px;
}

.save {
  background-color: #054a48;
  color: white;
  width: 150px;
  border: none;
  border-radius: 0px;
}

button:hover {
  background-color: #0a696f;
  color: white;
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/recommendInfoComponent.vue